export const ManifestManagerApiSymbol = Symbol('ManifestManagerApi')
